/* istanbul ignore file */

export enum MFEPackageIds {
  PORTFOLIO_BUILDER_PKG = 'portfolio-builder-pkg',
  RISK_QUIZ_PKG_ROE = 'risk-quiz-pkg-roe',
  SETTLEMENT_FUND_PKG = 'settlement-fund-pkg',
}
